import { useEffect, useMemo } from 'react'
import Navbar from '@app/components/Navbar'
import Button from '@app/components/Button'
import Footer from '@app/components/Footer'
import { FormattedMessage, useIntl } from 'react-intl'
import Faq from '@app/components/Faq'
import { useNavigate, useParams } from 'react-router-dom'
import useCampaignHref from '@app/hooks/useCampaignHref'
import { unflatten } from 'flat'
import { UnflattenedLangProps } from '@app/lang/types'
import { nanoid } from 'nanoid'
import Step from './components/Step'
import S from './Home.styles'

const Home = () => {
  const params = useParams<{ program: string; campaign?: string }>()
  const { messages } = useIntl()
  const navigate = useNavigate()

  const { href: customerUrl } = useCampaignHref({ requestPath: 'quiz/customer' })
  const { href: quizCustomerHref } = useCampaignHref({ requestPath: 'quiz/customer' })

  const data = useMemo(() => {
    const source = unflatten(messages) as UnflattenedLangProps
    return (
      source?.landing_page?.content?.step_list?.steps?.map(step => ({
        id: nanoid(),
        content: step.content,
        image: step.image,
      })) ?? []
    )
  }, [messages])

  // Redirect to the quiz page if the program is unieuro
  useEffect(() => {
    if (params.campaign === 'unieuro') {
      navigate(customerUrl)
    }
  }, [navigate, params.campaign, customerUrl])

  return (
    <>
      <Navbar />
      <S.Main>
        <>
          <S.Hero>
            <S.HeroInner>
              <S.HeroContent>
                <p className="home_pretitle">
                  <FormattedMessage id="landing_page.content.banner.pre_title" />
                </p>
                <h1>
                  <FormattedMessage id="landing_page.content.banner.title" />
                </h1>
                <p>
                  <FormattedMessage id="landing_page.content.banner.intro" />
                </p>
                <Button to={quizCustomerHref}>
                  <FormattedMessage id="landing_page.content.banner.button_text" />
                </Button>
              </S.HeroContent>
              <img src={messages['landing_page.content.banner.image'] as string} alt="" />
              <Button to={quizCustomerHref}>
                <FormattedMessage id="landing_page.content.banner.button_text" />
              </Button>
            </S.HeroInner>
            <span className="pattern" />
          </S.Hero>
          <S.StepSection>
            <h4>
              <FormattedMessage id="landing_page.content.step_list.title" />
            </h4>
            <S.StepList>
              {data.map(s => (
                <Step key={s.id} content={s.content} icon={s.image ?? ''} />
              ))}
            </S.StepList>
            <Button to={quizCustomerHref}>
              <FormattedMessage id="landing_page.content.step_list.button_text" />
            </Button>
          </S.StepSection>
          <S.FooterTerms>
            <p className="smallText">
              <FormattedMessage id="landing_page.content.step_list.small_print" />
            </p>
          </S.FooterTerms>
        </>
      </S.Main>
      <Faq />

      <Footer />
    </>
  )
}

export default Home
